import React, { Component } from "react";
import { connect } from "react-redux";
import Dropzone from "react-dropzone";
import { setBSECWallet } from "../../../actions/passport/set";
import {genWallet, getETHAddress} from "../../../actions/helpers/simpleWallet";
import M from "materialize-css/dist/js/materialize.min.js";
import $ from "jquery";
import Modal from "../../helper/modal";
import ShowGen from "./showGen";
import "./start.css";
import Ring from "./ring";
import {SteppedLineTo} from 'react-lineto';
var FileSaver = require("file-saver");

class Start extends Component {
  constructor() {
    super();
    this.state = {
      files: [],
      wallet: null,
      view: "mnemonic",
      view2: "mnemonic",
      viewAbove: "generate",
      continue: false
    };
  }
  setView(view) {
    this.setState({ view });
    let _this = this;
    setTimeout(() => {
      _this.setState({ view2: view });
    }, 100);
  }
  renderModalWallet() {
    let component = (
      <div>
        <div className="col s12">
          <ShowGen wallet={this.state.wallet} />
        </div>
      </div>
    );
    return (
      <Modal
        style={{maxWidth:'500px'}}
        id="modalWallet"
        noClose={true}
        classes="modal modalOrders black-text"
        title="Create Wallet"
        decryption={true}
        confirmPass={true}
        passwordId={'passwordGen'}
        component={component}
        buttonText={"Download and Upload Wallet*"}
        buttonAction={this.saveWallet.bind(this)}
        note={'*Save this wallet in a safe and secure manner'}
      />
    );
  }
  saveWallet2(event) {
    setTimeout(() => {
      var blob = new Blob([JSON.stringify(this.state.wallet)], {
        type: "text/javascript;charset=utf-8"
      });
      FileSaver.saveAs(blob, "wallet.json");
    }, 100);
  }
  saveWallet(event) {
    if (event && event.preventDefault) event.preventDefault();
    let pass = $("#passwordGen").val();
    let pass2 = $("#passwordGenConfirm").val();
    if (pass !==pass2) {
      M.toast({ html: "Passwords don't match", classes: "red" });
      return;
    }
    if (pass2 === "") {
      M.toast({ html: "Password not set", classes: "red" });
      return;
    }
    let _this = this;
    setTimeout(() => {
      var blob = new Blob([JSON.stringify(this.state.wallet)], {
        type: "text/javascript;charset=utf-8"
      });
      FileSaver.saveAs(blob, "wallet.json");
      _this.props.setBSECWallet(this.state.wallet, pass, (err, succ) => {
        if (err) M.toast({ html: "Unable to Link", classes: "red" });
        else {
          let location = window.localStorage.getItem('location')
          console.log({location})
          if(location) window.location.href = location;
        }
      });
    }, 100);
  }
  async openModalWallet() {
    let wallet = await genWallet(null);
    this.setState({ wallet });
    setTimeout(() => {
      var instance = M.Modal.getInstance(
        document.querySelectorAll("#modalWallet")[0]
      );
      instance.open();
    }, 300);
  }
  renderModal() {
    let addr = '';
    if(this.state.wallet && this.state.wallet.ethWallet) addr = this.state.wallet.ethWallet.address;
    if(this.state.wallet && this.state.wallet.eth) addr = this.state.wallet.eth.address;
    let component = (
      <div className='mbd'>
        <div className="col" style={{padding:'5px 10px'}}>
          <p style={{ color: "grey" }}>Address:</p>
          <p style={{ color: "black"}}>{addr}</p>
        </div>
      </div>
    )
    return (
      <Modal
        style={{maxWidth:'500px'}}
        component={component}
        id="modal"
        classes="modal modalOrders black-text"
        title="Import Wallet"
        decryption={true}
        confirmPass={true}
        noClose={true}
        buttonText={"Confirm"}
        chain="BSEC"
        buttonAction={this.submitOperation.bind(this)}
      />
    );
  }
  setViewAbove(viewAbove) {
    this.setState({ viewAbove });
    if(viewAbove == 'import') this.setState({showLines:true})
    else this.setState({showLines:false})
  }
  submitOperation() {
    let pass = $("#password").val();
    let pass2 = $("#passwordConfirm").val();
    if (pass !==pass2) {
      M.toast({ html: "Passwords don't match", classes: "red" });
      return;
    }
    if (pass2 === "") {
      M.toast({ html: "Password not set", classes: "red" });
      return;
    }
    let _this = this;
    // setTimeout(() => {
    _this.props.setBSECWallet(this.state.wallet, pass, (err, succ) => {
      console.log({err})
      if (err) M.toast({ html: "Unable to Link Wallet", classes: "red" });
      else {
        let location = window.localStorage.getItem('location')
        if(location) window.location.href = location;
      }
    });
    // }, 100);
  }
  onDrop(files) {
    var reader = new FileReader();
    let _this = this;

    // Closure to capture the file information.
    reader.onload = (function(theFile) {
      return function(e) {
        try {
          let json = JSON.parse(e.target.result);
          if (json && (json.eth || json.ethWallet)) {
            if(json.eth) json.ethWallet = json.eth;
            _this.setState({ wallet: json });
            var instance = M.Modal.getInstance(document.querySelectorAll("#modal")[0]);
            if(instance) instance.open();
            setTimeout(() => {
              if ($("#password")) $("#password").focus();
            }, 100);
          } else {
            M.toast({
              html: "Incorrect Wallet Format - please upload a BSEC Wallet",
              classes: "red"
            });
          }
        } catch (ex) {
          M.toast({
            html: "Incorrect Wallet Format - please upload a BSEC Wallet",
            classes: "red"
          });
        }
      };
    })(files[0]);
    reader.readAsText(files[0]);
  }
  processPriv() {
    let privKey = $("#priv").val().trim();
    if (privKey.substring(0, 2) === "0x") privKey = privKey.substring(2);

    let ethAddress = getETHAddress(privKey);

    if (ethAddress) {
      let wallet = {
        ethWallet: {
          address: ethAddress,
          privateKey: privKey
        }
      };
      this.setState({ wallet });
      var instance = M.Modal.getInstance(document.querySelectorAll("#modal")[0]);
      instance.open();
      setTimeout(() => {
        if ($("#password")) $("#password").focus();
      }, 100);
    } else {
      M.toast({ html: "Incorrect Private Key", classes: "red" });
    }
  }
  async processMnem() {
    let wallet = await genWallet($("#mnem").val());
    this.setState({ wallet });
    var instance = M.Modal.getInstance(document.querySelectorAll("#modal")[0]);
    instance.open();
    setTimeout(() => {
      if ($("#password")) $("#password").focus();
    }, 100);
  }
  processWallet() {
    var instance = M.Modal.getInstance(document.querySelectorAll("#modal")[0]);
    instance.open();
    setTimeout(() => {
      if ($("#password")) $("#password").focus();
    }, 100);
  }
  renderGenerate() {
    return (
      <div className="center">
        <hr/>
        <button onClick={this.openModalWallet.bind(this)} className="btn clickablesWhiteBig" style={{ margin: '20px'}}>
          Create Wallet
        </button>
      </div>
    );
  }
  renderImport() {
    let mnemStyle = this.state.view === "mnemonic" ? { color: "white",margin:'10px' } : { color: "grey",margin:'10px'};
    let jsonStyle = this.state.view === "json" ? { color: "white",margin:'10px' } : { color: "grey",margin:'10px' };
    let privStyle = this.state.view === "private" ? { color: "white",margin:'10px' } : { color: "grey",margin:'10px'};

    return (
      <div>
        <div className="row center" style={{marginTop:'10px'}}>
          <div className="col s4">
            <div onClick={this.setView.bind(this, "mnemonic")} className='B' style={{cursor:'pointer',border:this.state.view === "mnemonic" ? '1px solid white':'1px solid grey'}}>
              <h5 style={mnemStyle}> mnemonic </h5>
            </div>
          </div>
          <div className="col s4">
            <div onClick={this.setView.bind(this, "json")} className='C' style={{cursor:'pointer',border:this.state.view === "json" ? '1px solid white':'1px solid grey'}}>
              <h5 style={jsonStyle}> json </h5>
            </div>
          </div>
          <div className="col s4">
            <div onClick={this.setView.bind(this, "private")} className='D' style={{cursor:'pointer',border:this.state.view === "private" ? '1px solid white':'1px solid grey'}}>
              <h5 style={privStyle}> private key </h5>
            </div>
          </div>
        </div>

        <div className='row center' style={{marginTop:'20px',paddingBottom:'20px'}}>

        {this.state.view2 === "json" && (
          <Dropzone onDrop={this.onDrop.bind(this)}>
            {({ getRootProps, getInputProps }) => (
              <div className="center" style={{ cursor: "pointer", zIndex: 15}} {...getRootProps()}>
                <input {...getInputProps()} />
                <button className="btn clickablesWhiteBig" style={{width:'180px',margin: 0}}>
                  Import JSON Wallet
                </button>
              </div>
            )}
          </Dropzone>
        )}

        {this.state.view2 === "mnemonic" && (
          <div className="center">
            <div className="input-field col s12" style={{ marginBottom: "3vh" }}>
              <form onSubmit={this.processMnem.bind(this)} autoComplete="off">
                <input id={'mnem'} placeholder={'Mnemonic Phrase'} className="passwordClassWhite" type="password" required={true} />
              </form>
            </div>
            <button className="btn clickablesWhiteBig" style={{ margin: 0}} onClick={this.processMnem.bind(this)}>
              Import Wallet
            </button>
          </div>
        )}

        {this.state.view2 === "private" && (
          <div className="center">
            <div className="input-field col s12" style={{ marginBottom: "3vh" }}>
              <form onSubmit={this.processPriv.bind(this)} autoComplete="off">
                <input id={'priv'} placeholder={'Private Key'} className="passwordClassWhite" type="password" required={true} />
              </form>
            </div>
            <button className="btn clickablesWhiteBig" style={{ margin: 0,width:'150px' }} onClick={this.processPriv.bind(this)}>
              Import Wallet
            </button>

          </div>
        )}
        </div>

      </div>
    );
  }
  render() {
    return (
      <div className='container'>
        <Ring />
        {this.renderModal()}
        <div className="five container login" style={{marginTop:'50px',padding:'10px'}}>
          {this.state.wallet && this.renderModalWallet()}
          {this.renderImport()}
          {this.renderGenerate()}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  { setBSECWallet }
)(Start);
